export class ApiError extends Error {
  constructor(message: string, public cause?: unknown) {
    super(message)
    this.name = 'ApiError'
  }
}

export function normalizeError(err: any, fallback = 'Unexpected error') {
  const message = err?.message || err?.error?.message || fallback
  return new ApiError(message, err)
}

